var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 502 502",
    style: {
      enableBackground: "new 0 0 502 502"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B1D952"
    },
    d: "M304.48,252.627c0.189-34.414-27.656-62.412-62.07-62.412H71.589 C37.575,190.215,10,218.063,10,252.416v213.085l60.583-39.93h171.699c34.015,0,61.589-27.849,61.589-62.202L304.48,252.627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B706"
    },
    d: "M242.41,190.215H71.589c-4.652,0-9.178,0.538-13.535,1.525v70.988 c0,72.381,58.527,131.267,130.467,131.267h107.361c5.077-9.043,7.989-19.488,7.989-30.625l0.609-110.742 C304.669,218.213,276.824,190.215,242.41,190.215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDCB50"
    },
    d: "M188.521,36.499h223.012c44.441,0,80.467,36.385,80.467,81.267v278.398l-84.478-52.169H188.521 c-44.441,0-80.467-36.385-80.467-81.268V117.766C108.054,72.883,144.08,36.499,188.521,36.499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD8F01"
    },
    d: "M178.269,112.657c0-26.589,4.247-52.182,12.071-76.159h-1.819 c-44.441,0-80.467,36.385-80.467,81.267v144.961c0,44.883,36.026,81.268,80.467,81.268h153.305 C246.543,310.322,178.269,219.47,178.269,112.657z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#052A75",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M108.054,190.215H71.589C37.575,190.215,10,218.063,10,252.416v213.085l60.583-39.93h171.699 c34.015,0,61.589-27.849,61.589-62.202v-17.798"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#052A75",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M188.521,36.499h223.012c44.441,0,80.467,36.385,80.467,81.267v278.398l-84.478-52.169H188.521 c-44.441,0-80.467-36.385-80.467-81.268V117.766C108.054,72.883,144.08,36.499,188.521,36.499z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M198.847,117.45L198.847,117.45c12.975,0,23.922,9.754,25.539,22.756l4.009,32.232c2.58,20.743,20.044,36.304,40.744,36.304 h61.774c20.7,0,38.164-15.561,40.745-36.304l4.009-32.232c1.617-13.002,12.564-22.756,25.539-22.756l0,0"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 300.027,
    y1: 119.867,
    x2: 300.027,
    y2: 276.667
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.2c7f64fc5709c9184ea16928c796b6ff.svg";
export { ForwardRef as ReactComponent };